export const SLIDER_BREAKPOINTS = {
  mobile: 576,
  tablet: 768,
  desktop: 1024,
  largeDesktop: 1280,
};

export const SLIDER_CONFIG = {
  slidesPerView: 2.3,
  mobileSlidesPerView: 2.42,
  tabletSlidesPerView: 3,
  desktopSlidesPerView: 4,
  largeDesktopSlidesPerView: 5,
} as const;
